import type { Lang } from '../store';
import { tr } from '../i18n';

export function shellHeader(lang: Lang): string {
  const L = tr(lang);
  return /* html */ `
    <header class="sq-header">
      <div class="sq-logo">
        <span class="sq-logo-mark">S</span>
        <span>Sniff Quest</span>
      </div>
      <div class="sq-lang">
        <button data-lang="ro" class="${lang === 'ro' ? 'is-active' : ''}">${L.lang_ro}</button>
        <button data-lang="en" class="${lang === 'en' ? 'is-active' : ''}">${L.lang_en}</button>
      </div>
    </header>
  `;
}

export function shellFooter(lang: Lang): string {
  const L = tr(lang);
  return /* html */ `
    <footer class="sq-footer">
      <div class="sq-footer-inner">
        <div class="sq-partners">
          <span class="label">${L.powered_by}</span>
          <strong>Sniffary</strong>
          <span class="sep">×</span>
          <strong>Boopr</strong>
          <span class="sep">×</span>
          <strong>Mash</strong>
          <span class="sep">×</span>
          <strong>Abry's Treats</strong>
        </div>
        <div class="sq-footer-note">
          ${L.note}
          <span class="sq-footer-sep">·</span>
          <a href="/admin/" class="sq-footer-admin">admin</a>
        </div>
      </div>
    </footer>
  `;
}
